import { render, staticRenderFns } from "./card-page.vue?vue&type=template&id=d3ec0da0&"
import script from "./card-page.vue?vue&type=script&lang=js&"
export * from "./card-page.vue?vue&type=script&lang=js&"
import style0 from "./card-page.vue?vue&type=style&index=0&id=d3ec0da0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports